export default __webpack_public_path__ + "static/media/phone2.c469c279.png";